import React, { Component } from "react";
import { withStyles } from '@material-ui/styles';
import { connect } from "react-redux";
import { Zoom, Fade, Grow } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Collapse from '@material-ui/core/Collapse';
import clsx from 'clsx';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { setMainBackground } from '../../settings/actions/settings.action';
import ProductsFooterContainer from '../../common/containers/ProductsFooterContainer'
import { FormGroup, RadioGroup, FormControl, Radio, Checkbox, FormControlLabel } from '@material-ui/core/';
// import FormLabel from '@material-ui/core/FormLabel';
import Lightbox from 'react-image-lightbox';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ProductListItem from "./ProductListItem";
import ProductVariantsModal from "../../common/modals/ProductVariant";
import IngredientGroupsSelector from "./IngredientGroupsSelector";
import { getProductsBySubcat, addProductTooltip, addToCart, changeSelectedCartTab, setOrderComment, removeProductPageId, setProductPageId, setCommentModalData, getProductIngredients } from '../actions/products.action';
import { showHeaderCategory } from '../../categories/actions/categories.action';
import { setScrollData, setAlertMessage } from '../../menu/menu.actions';
import Page404 from '../../common/errors/404'
import { DEMO } from '../../constants';
import MetaAndOg from '../../common/MetaAndOg'
import AddIcon from '@material-ui/icons/Add';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TextField from '@material-ui/core/TextField';


import Utils from "../../utils/Utils";
import Auth from "../../utils/Auth";
import history from "../../utils/history";

const styles = theme => ({
    viewProductContainer: {
        // position: 'absolute',
        // width: '100%',
        // height: '100%',
        background: 'white',
        // zIndex: 2,
    },

    productInfoContainer: {
        paddingTop: 80,
        display: 'grid',
        gridTemplateColumns: '45% 55%',
        alignItems: 'start',
        '@media screen and (max-width: 1000px)': {
            paddingTop: 60,
            gridTemplateColumns: 'none',
            gridTemplateRows: 'auto',
        }
    },

    productImageContainer: {
        textAlign: 'center',
        display: 'block',
        margin: '0 auto',
        width: '95%',
        height: 520,
        maxHeight: '70vh',
        marginBottom: 20,
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        position: 'sticky',
        // Закача се така, че да е вертикално центрирана спрямо viewport-а (не контейнера).
        // Височина 520px → top = (100vh - 520px) / 2 = calc(50vh - 260px)
        top: 'calc(50vh - 260px)',
        alignSelf: 'start',
        overflow: 'hidden',
        borderRadius: 18,
        transition: 'height .5s',
        '@media screen and (max-width: 1000px)': {
            position: 'static',
            top: 'auto',
            width: '92%',
            height: 280,
            maxHeight: '42vh',
            marginBottom: 10,
            borderRadius: 14,
        },
    },
    productTextContainer: {
        textAlign: 'center',
        display: 'grid',
        'align-items': 'center'
    },
    productNameContainer: {
        fontSize: 26,
        textTransform: 'uppercase',
        padding: '0 20px',
        '@media screen and (max-width: 1000px)': {
            fontSize: 23,
        }
    },
    productSubContainer: {
        background: '#000',
        color: 'white',
        padding: '10px 0',
        fontSize: 16,
        textTransform: 'uppercase',
        fontStyle: 'italic',
        '@media screen and (max-width: 1000px)': {
            fontSize: 13,
        },
        width: '90%',
        margin: '0 auto',
        maxWidth: 600,
        marginTop: 40,
    },
    productDescriptionContainer: {
        color: '#343434',
        fontSize: 19,
        padding: '0 20px',
        '@media screen and (max-width: 1000px)': {
            fontSize: 17,
        }
    },

    commentTextField: {
        // display: flex → block-level, за да заема собствен ред (иначе MUI inline-flex
        // го слага до бутона „Добави в количката" на широк екран).
        display: 'flex',
        width: '90%',
        margin: '0 auto',
        marginTop: 20,
        maxWidth: 600,
        '& label.Mui-focused': {
            color: '#848484',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(254, 105, 2, .7)',
            },
        },
    },

    ProductVariantsContainer: {
        width: '90%',
        margin: '0 auto',
        maxWidth: 600,
        marginTop: 40,
    },

    ProductIngridientsContainer: {
        width: '90%',
        margin: '0 auto',
        maxWidth: 600,
        marginTop: 40,
    },

    addToCartButton: {
        // display: flex → block-level, за да е на собствен ред под коментара
        // (иначе MUI inline-flex го слага до полето за коментар на широк екран).
        display: 'flex',
        background: '#ff8100',
        width: '90%',
        margin: '0 auto',
        color: 'white',
        borderRadius: 5,
        padding: 10,
        maxWidth: 600,
        marginTop: 20,

        '&:hover': {
            background: '#ff8100',
        }
    },

    // Бутон „Назад" под „Добави в количката" — със същия размер, но леко сив.
    backButton: {
        display: 'flex',
        background: '#e0e0e0',
        width: '90%',
        margin: '0 auto',
        color: '#555',
        borderRadius: 5,
        padding: 10,
        maxWidth: 600,
        marginTop: 12,

        '&:hover': {
            background: '#d5d5d5',
        }
    },

    productsContainer: {
        WebkitOverflowScrolling: 'touch',
        width: '90%',
        margin: '0 auto',
        paddingTop: 65,
        paddingBottom: 70, // temp unable to hive navbar fix
    },

    similarProductsContainer: {
        fontSize: 26,
        textTransform: 'uppercase',
        textAlign: 'center',
        marginTop: 60,
        '@media screen and (max-width: 1000px)': {
            marginTop: 60,
            paddingTop: 60,
            borderTop: '1px solid #ccc',
            fontSize: 24,
        }
    },
    errorContainer: {
        color: '#ff0c00f0',
        textAlign: 'center',
        fontWeight: 'bold',
        borderBottom: '1px solid #ff0c00f0',
        // marginTop: 17,
        // marginBottom: 5,
    },

    activeProductVariant: {
        border: '1px solid #ccc',
        'background-color': '#e6e6e6',
        borderRadius: 3,
        '&:hover': {
            'background-color': '#e6e6e6'
        }
    },

    allergensContainer: {
        width: '90%',
        margin: '0 auto',
        marginTop: 20,
        maxWidth: 600,
        textAlign: 'left'
        // textAlign: 'center'
    },
    groupContainer: {
        display: 'block',
    },
    requiredIngredientsRadio: {
        margin: 0,
        color: 'rgb(254, 105, 2)',
        '&.Mui-checked': {
            color: 'rgb(254, 105, 2)',
        },
    },
    variantCheckbox: {
        margin: 0,
        color: 'rgb(254, 105, 2)',
        '&.Mui-checked': {
            color: 'rgb(254, 105, 2)',
        },
    },
    addableIngredientsCheckbox: {
        margin: 0,
        color: '#008017',
        '&.Mui-checked': {
            color: '#008017',
        },
    },
    removableIngredientsCheckbox: {
        margin: 0,
        color: '#c50000',
        '&.Mui-checked': {
            color: '#c50000',
        },
    },
    activeRemovableIngredients: {
        // margin: 0,
        color: '#c50000',
        // '&.Mui-checked': {
        //     color: '#c50000',
        // },
    },
    productIngredientsContainerTitle: {
        background: 'rgba(254, 105, 2, 0.33)',
        padding: 10,
    },
    nutritionContainer: {
        width: '90%',
        margin: '20px auto 0',
        maxWidth: 600,
        border: '1px solid #eee',
        borderRadius: 10,
        padding: '12px 14px',
        background: '#fafafa',
        textAlign: 'left',
    },
    nutritionTitle: {
        fontSize: 13,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        color: '#888',
        marginBottom: 8,
    },
    nutritionGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 6,
        textAlign: 'center',
    },
    nutritionCell: {
        display: 'flex',
        flexDirection: 'column',
    },
    nutritionValue: {
        fontSize: 18,
        fontWeight: 700,
        color: '#333',
    },
    nutritionLabel: {
        fontSize: 11,
        color: '#999',
        textTransform: 'uppercase',
    }
});

class ViewProductPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            productComment: '',
            productActiveVariantId: 0,
            viewPageError: false,
            timeout: 0,
            openCommentModal: false,
            commentModalTitle: '',
            commentVariantId: '',
            selectedRequiredProductIngredient: 0,
            selectedRequiredProductIngredient2: 0,
            // Избраното от конфигурируемите групи: { groupId: [{ id, qty }] }
            selectedIngredientGroups: {},
            selectedAddableProductIngredients: [],
            selectedRemovableProductIngredients: [],
            // checkedIngredient: {}
            photoOpened: false,
        }
    }

    componentDidUpdate() {

        // console.log('updated: ', window.location.href)
        const cp = this.props.currentProduct;
        if (!cp || !cp.product_variants || !cp.product_variants[0] || !cp.product_variants[0].id) {
            return;
        }
        const variants = cp.product_variants;

        // Ако сме дошли от бутон „Добави" на конкретен вариант (add_btn_opens_product),
        // маркираме точно избрания вариант — независимо от текущо избрания (напр. при повторно отваряне).
        try {
            const raw = sessionStorage.getItem('preselect_variant');
            if (raw) {
                const parsed = JSON.parse(raw);
                if (parsed && parsed.productId == cp.id && variants.findIndex(pv => pv.id == parsed.variantId) > -1) {
                    sessionStorage.removeItem('preselect_variant');
                    if (this.state.productActiveVariantId != parsed.variantId) {
                        this.setState({ productActiveVariantId: parsed.variantId });
                    }
                    return;
                }
                // Различен продукт (преходен рендер) — оставяме ключа за съответния продукт.
            }
        } catch (e) { }

        // По подразбиране се избира първият вариант, когато няма валиден избор.
        if (this.state.productActiveVariantId == 0 || variants.findIndex(pv => pv.id == this.state.productActiveVariantId) == -1) {
            this.setState({ productActiveVariantId: variants[0].id });
        }
    }


    // Връща към списъка (като горния „Назад"): затваря продукта и маха слъга от URL-а.
    goBackFromProduct = () => {
        this.props.removeProductPageId();
        const path = history.location.pathname;
        const parentPath = path.substring(0, path.lastIndexOf('/')) || '/';
        history.push(parentPath);
    }

    // Opens variant modal or adds prod to cart
    addToCartBtnClicked = (id, productVariantId = 0, useIngredients = true) => {
        const { translations, currentProduct } = this.props;
        if (currentProduct && currentProduct.min_count_addable_ingredients && currentProduct.min_count_addable_ingredients > 0 && this.state[this.getIngredientStates("addable")].length < currentProduct.min_count_addable_ingredients) {
            // Cant add to cart
            this.setState({ viewPageError: translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.min_count_addable_ingredients_reached ? Utils.translate(translations.translations.pages.products.min_count_addable_ingredients_reached, { value: currentProduct.min_count_addable_ingredients }) : '' });
            this.props.setAlertMessage(true, translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.min_count_addable_ingredients_reached ? Utils.translate(translations.translations.pages.products.min_count_addable_ingredients_reached, { value: currentProduct.min_count_addable_ingredients }) : '');
        } else {
            // Add to cart
            // const currProduct = this.props.subcategory.products.filter(p => p.id == id)[0];
            const currProduct = Object.values(this.props.products.all_products).filter(p => p.id === id)[0];

            if (currProduct.product_variants) {
                if (currProduct.product_variants.length === 1 || productVariantId > 0) {
                    this.addProdToCart(id, productVariantId ? productVariantId : currProduct.product_variants[0].id, currProduct, useIngredients);
                    this.setState({ viewPageError: false });
                } else {
                    if (this.state.productActiveVariantId === 0) {
                        // Show no variant error
                        this.setState({ viewPageError: translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.variant_not_choosed ? translations.translations.pages.products.variant_not_choosed : '' });
                    } else {
                        this.setState({ viewPageError: false });
                        this.addProdToCart(id, currProduct.product_variants.filter(pv => pv.id == this.state.productActiveVariantId)[0].id, currProduct, useIngredients);
                    }
                }
            }
        }

    }

    // Конфигурируемите групи на текущия продукт, подредени както са в админа.
    // Продукт без групи връща празен масив и целият нов код става no-op.
    getProductIngredientGroups = (product = null) => {
        const currentProduct = product || this.props.currentProduct;
        if (!currentProduct || !this.props.ingredientGroups) return [];

        return Object.values(this.props.ingredientGroups)
            .filter(group => group && parseInt(group.productId) === parseInt(currentProduct.id))
            .filter(group => group.options && group.options.length > 0)
            .sort((a, b) => (parseFloat(a.priority) || 0) - (parseFloat(b.priority) || 0) || a.id - b.id);
    }

    // Задължителна група с точно една опция няма какво да пита - избира се сама, за да не
    // блокира бутона "Добави" (същото поведение като на старата required група).
    getGroupSelectionsWithDefaults = () => {
        const stateSelections = this.state.selectedIngredientGroups || {};
        const selections = {};

        // Взимат се САМО групите на текущия продукт - страницата се преизползва при
        // навигация между продукти, така че избор от предишния продукт не бива да пътува.
        this.getProductIngredientGroups().map(group => {
            const picked = stateSelections[group.id];
            if (picked && picked.length > 0) {
                selections[group.id] = picked;
                return;
            }

            if ((parseInt(group.min_select) || 0) > 0 && group.options.length === 1) {
                selections[group.id] = [{ id: parseInt(group.options[0].ingredientId), qty: 1 }];
            }
        });

        return selections;
    }

    // Първата група, чийто минимум не е изпълнен - използва се, за да покаже бутонът
    // "Избери Протеин" вместо мълчаливо да е неактивен.
    getUnsatisfiedGroup = () => {
        const selections = this.getGroupSelectionsWithDefaults();

        return this.getProductIngredientGroups().find(group => {
            const min = parseInt(group.min_select) || 0;
            if (min === 0) return false;

            const picks = selections[group.id] || [];
            const units = picks.reduce((sum, p) => sum + (parseInt(p.qty) || 1), 0);
            return units < min;
        }) || null;
    }

    groupTitleFor = (group) => {
        if (!group) return '';
        const currLang = this.props.currLang;
        if (group.translations && group.translations[currLang] && group.translations[currLang].name) {
            return group.translations[currLang].name;
        }
        return group.name || '';
    }

    // "Изберете Протеин" - конкретно, вместо мълчаливо неактивен бутон.
    groupSelectPrompt = (group) => {
        const { translations } = this.props;
        const label = translations && translations.translations && translations.translations.pages
            && translations.translations.pages.products && translations.translations.pages.products.choose
            ? translations.translations.pages.products.choose
            : 'Изберете';

        return label + ' ' + this.groupTitleFor(group);
    }

    // Add variant to cart
    addProdToCart = (product_id, product_variant_id, product, useIngredients = true) => {
        // Задължителна група без избор спира добавянето. Сървърът пази същото правило,
        // това тук е само за да не се стига дотам с изненада.
        if (useIngredients) {
            const unsatisfied = this.getUnsatisfiedGroup();
            if (unsatisfied) {
                const message = this.groupSelectPrompt(unsatisfied);
                this.setState({ viewPageError: message });
                this.props.setAlertMessage(true, message);
                return;
            }
        }

        const { product_ingredients } = this.props.currentProduct;
        const requiredProductIngridients = product_ingredients.filter(pi => pi.type == 'required' && this.props.productIngredients[pi.ingredientId] && this.props.productIngredients[pi.ingredientId].active == true);
        const requiredProductIngridients2 = product_ingredients.filter(pi => pi.type == 'required2' && this.props.productIngredients[pi.ingredientId] && this.props.productIngredients[pi.ingredientId].active == true);

        let defautRequiredProductIngridient = parseInt(this.state.selectedRequiredProductIngredient);
        if (!defautRequiredProductIngridient) {
            if (requiredProductIngridients && requiredProductIngridients[0] && requiredProductIngridients[0].ingredientId) {
                defautRequiredProductIngridient = requiredProductIngridients[0].ingredientId;
            }
        }

        // Second required group defaults to its first ingredient when nothing is chosen (mirrors group 1).
        let defautRequiredProductIngridient2 = parseInt(this.state.selectedRequiredProductIngredient2);
        if (!defautRequiredProductIngridient2) {
            if (requiredProductIngridients2 && requiredProductIngridients2[0] && requiredProductIngridients2[0].ingredientId) {
                defautRequiredProductIngridient2 = requiredProductIngridients2[0].ingredientId;
            }
        }

        const selectedIngredients =
            useIngredients ?
                {
                    required: defautRequiredProductIngridient,
                    required2: defautRequiredProductIngridient2,
                    addable: this.state.selectedAddableProductIngredients,
                    removable: this.state.selectedRemovableProductIngredients,
                    // Конфигурируеми групи. Празен обект за продукти без групи.
                    groups: this.getGroupSelectionsWithDefaults(),
                }
                :
                {
                    // Default empty structure so the cart can match/remove this item later.
                    // Without `required` key, getUpdatableIndex / differentIngridients fail to find the row.
                    required: 0,
                    required2: 0,
                    addable: [],
                    removable: [],
                    groups: {},
                }

        const hasComment = !!(this.state.productComment && this.state.productComment.length > 0);

        this.showAddedProductTooltip(product_id, product_variant_id, product, selectedIngredients);
        this.props.changeSelectedCartTab(0); // select default tab "Cart"
        // When a comment is set, add the product as a separate cart line (forceNewLine) and attach the comment to that exact line via its cart_item_uuid.
        const addedUuid = this.props.addToCart(product_id, product_variant_id, product, selectedIngredients, this.props.selectedCat && this.props.selectedCat.id || null, hasComment);
        if (hasComment && addedUuid) {
            this.addCommentToOrder(product_variant_id, this.state.productComment, addedUuid);
            this.setState({ productComment: '' });
        }

    };


    // Shows tooltip
    showAddedProductTooltip = (id, product_variant_id, product, selectedIngredients) => {
        let totalProdQuantity = 1;
        if (this.props.products && this.props.products.to_order && this.props.products.to_order[0] && this.props.products.to_order[0].length > 0) {
            totalProdQuantity = Utils.getCartProductQuantity(product_variant_id, selectedIngredients);
        }

        // if (this.props.products && this.props.products.to_order && Object.keys(this.props.products.to_order).length > 0) {
        //     console.log('this.props.products.to_order', this.props.products.to_order)
        //     const addedProductVariant = this.props.products.to_order.find(pv => pv.product_variant_id === product_variant_id);
        //     if (addedProductVariant) {
        //         totalProdQuantity = parseInt(addedProductVariant.quantity) + 1;
        //     }
        // }
        let choosedProductVariant = product.product_variants.filter(pv => pv.id === product_variant_id)[0];
        let tooltipText = totalProdQuantity + ' x ' + product.name + ' - /' + choosedProductVariant.size + '/';

        // Add to cart tooltip
        const addProdTooltip = (id, tooltipText) => this.props.addProductTooltip(id, tooltipText);
        if (this.state.timeout) {
            clearTimeout(this.state.timeout);
            this.setState({ timeout: null });
        }
        addProdTooltip(id, tooltipText);
        // Comment is attached to the specific new cart line (by cart_item_uuid) in addProdToCart, after the line is created.
        let timeOut = setTimeout(function () { addProdTooltip(0, tooltipText); }, 2500);
        this.setState({ timeout: timeOut });
    }


    addCommentToOrder = (variantId, comment, cartItemUuid = null) => {
        let stateComments = Object.values(this.props.products.order_comment);
        let validatedComments = Utils.validatedCommentObject(stateComments, variantId, comment, cartItemUuid)
        if (validatedComments) {
            this.props.setOrderComment(validatedComments)
        }
    }

    // componentWillReceiveProps(nextProps) {
    //     console.log('nextProps', nextProps)
    //     // if(nextProps.selectedCat) {
    //     //     this.setState({
    //     //         currHierarchyLevel: nextProps.selectedCat.hierarchyLevel
    //     //     })
    //     // }
    // }



    componentDidMount() {
        let { view_product_page_id, setProductPageId, products, getProductIngredients } = this.props;
        const self = this;
        // getProductIngredients();
        // window.onpopstate = function (event) {

        // console.log('tuka ?', self.props)
        // if (
        //     (view_product_page_id == 0)
        //     || (view_product_page_id > 0 && (this.props.currentProdSlug && this.props.currentProdSlug.length == 0))
        //     || (!this.props.currentProdSlug || (this.props.currentProdSlug && this.props.currentProdSlug.length == 0))
        // ) {

        if (self.props.currentProdSlug.length == 0) {
            setProductPageId(0);
        } else {
            // if (view_product_page_id == 0 && this.props.products && this.props.products.all_products && this.props.currentProdSlug && this.props.currentProdSlug.length > 0) {

            // console.log('products', products)
            // 
            const prodBySlug = Object.values(self.props.products.all_products).filter(p => p.slug == (self.props.currentProdSlug))
            // console.log('prodBySlug', prodBySlug)
            if (self.props.currentProdSlug && self.props.currentProdSlug.length > 0 && prodBySlug.length > 0 && prodBySlug[0] && prodBySlug[0].id) {
                // console.log('NA MAUNT', self.props.currentProdSlug)
                // viewProductPageId = prodBySlug[0].id;
                // console.log('viewProductPageId', prodBySlug[0].id)
                self.props.setProductPageId(prodBySlug[0].id);
            }


        }
        // }
        // alert("location: " + document.location + ", state: " + event.state + ' E: ' + event);
        // console.log('E', event)
        // };

        //     // console.log('state.products', state.products)
        //     console.log('window.location.hash', window.location.hash)
        //     console.log('this.props.products', this.props.products)
        //     if (window.location.hash && window.location.hash.length > 0) {
        //         const prodBySlug = Object.values(this.props.products.all_products).filter(p => p.slug == this.props.currentProdSlug)
        //         console.log('prodBySlug', prodBySlug)
        //         if (prodBySlug.length > 0 && prodBySlug[0] && prodBySlug[0].id) {
        //             // viewProductPageId = prodBySlug[0].id;
        //             console.log('viewProductPageId', prodBySlug[0].id)
        //         }
        //     }
    }

    componentWillReceiveProps(nextProps) {
        const { translations } = nextProps;
        let { view_product_page_id } = nextProps;

        // console.log('nextProps', nextProps)
        // console.log('nextProps.products', nextProps.products)
        // console.log('view_product_page_id', view_product_page_id)

        if (view_product_page_id == 0 && nextProps.products && nextProps.products.all_products && nextProps.currentProdSlug && nextProps.currentProdSlug.length > 0) {
            const prodBySlug = Object.values(nextProps.products.all_products).filter(p => p.slug == nextProps.currentProdSlug)
            // console.log('prodBySlug', prodBySlug)
            if (prodBySlug.length > 0 && prodBySlug[0] && prodBySlug[0].id) {
                // viewProductPageId = prodBySlug[0].id;
                // console.log('viewProductPageId', prodBySlug[0].id)
                // console.log('NA componentWillReceiveProps')

                nextProps.setProductPageId(prodBySlug[0].id);
            }


            // } else {
            //     if (nextProps.currentProdSlug.length == 0 && view_product_page_id != 0) {
            //         nextProps.setProductPageId(0);
            //         // console.log('DA ZATVAR{QM?')
            //     }
        }
        // if (window.location.hash.length > 0) {
        //     view_product_page_id = 
        // }

        //         if (parseInt(nextProps.view_product_page_id) > 0) {
        //         // if (this.state.productActiveVariantId != 0) {
        //             nextProps.showHeaderCategory(translations && translations.translations && translations.translations.common ? translations.translations.common.action.back : '');
        // //             // } else {
        // //             //     nextProps.showHeaderCategory('');
        // //             //     return
        //         }
    }


    checkedIngredient = (ingridientType, ingridientId) => {
        return this.state[this.getIngredientStates(ingridientType)] ? this.state[this.getIngredientStates(ingridientType)].includes(parseInt(ingridientId)) : false
    }

    getIngredientStates = (type) => {
        return type == 'addable' ? 'selectedAddableProductIngredients' : 'selectedRemovableProductIngredients';
    }

    handleIngridientChangeObject = (e, ingridient) => {
        const { translations } = this.props;
        let ingridientState = this.getIngredientStates(ingridient.type);

        if (this.state[ingridientState]) {
            const index = (this.state[ingridientState].indexOf(parseInt(ingridient.ingredientId)))
            if (index > -1) { // Ingredient was found - remove it
                if (ingridient.type == 'addable' && parseInt(this.props.currentProduct.min_count_addable_ingredients) > 0 && (parseInt(Object.keys(this.state[ingridientState]).length) <= (parseInt(this.props.currentProduct.min_count_addable_ingredients)))) {
                    // Error removing
                    this.setState({ viewPageError: translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.min_count_addable_ingredients_reached ? Utils.translate(translations.translations.pages.products.min_count_addable_ingredients_reached, { value: this.props.currentProduct.min_count_addable_ingredients }) : '' });
                    this.props.setAlertMessage(true, translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.min_count_addable_ingredients_reached ? Utils.translate(translations.translations.pages.products.min_count_addable_ingredients_reached, { value: this.props.currentProduct.min_count_addable_ingredients }) : '');
                } else {
                    // Real remove
                    let st = this.state;
                    st[ingridientState].splice(index, 1)
                    this.setState({ [ingridientState]: st[ingridientState] })
                }
            } else { // Add ingredient
                if (ingridient.type == 'addable' && parseInt(this.props.currentProduct.max_count_addable_ingredients) > 0 && (parseInt(Object.keys(this.state[ingridientState]).length) >= (parseInt(this.props.currentProduct.max_count_addable_ingredients)))) {
                    // Error adding
                    this.setState({ viewPageError: translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.max_count_addable_ingredients_reached ? Utils.translate(translations.translations.pages.products.max_count_addable_ingredients_reached, { value: this.props.currentProduct.max_count_addable_ingredients }) : '' });
                    this.props.setAlertMessage(true, translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.max_count_addable_ingredients_reached ? Utils.translate(translations.translations.pages.products.max_count_addable_ingredients_reached, { value: this.props.currentProduct.max_count_addable_ingredients }) : '');
                } else {
                    // Real add
                    let st = this.state;
                    st[ingridientState].push(parseInt(ingridient.ingredientId))
                    this.setState({ [ingridientState]: this.state[ingridientState] })
                }
            }
        }
    }

    ingredientsSortFunc = (a, b) => {
        let priorityOne = a.ingredient.priority * 1;
        let priorityTwo = b.ingredient.priority * 1;
        return (priorityOne < priorityTwo) ? -1 : ((priorityOne > priorityTwo) ? 1 : 0);
    }

    // Live nutrition for the product detail page: base (product + selected variant, additive)
    // + the currently selected required/addable extras. Recomputes on every render, so it
    // updates as the customer changes the variant or toggles extras (e.g. tomatoes).
    renderProductNutrition = () => {
        const { classes, settings, currentProduct, translations, productIngredients } = this.props;
        if (Utils.getSettingsValue(settings, 'show_nutrition_info') != '1' || !currentProduct) {
            return null;
        }
        const variants = (currentProduct.product_variants) || [];
        if (variants.length === 0) {
            return null;
        }
        const variant = variants.find(v => v.id == this.state.productActiveVariantId) || variants[0];
        // Base = product + selected variant (additive).
        const base = Utils.getBaseNutrition(currentProduct, variant);

        // Default required ingredient mirrors addProdToCart (first required when none chosen).
        let requiredId = parseInt(this.state.selectedRequiredProductIngredient);
        if (!requiredId) {
            const reqs = (currentProduct.product_ingredients || []).filter(pi => pi.type == 'required' && productIngredients[pi.ingredientId] && productIngredients[pi.ingredientId].active == true);
            if (reqs[0] && reqs[0].ingredientId) {
                requiredId = reqs[0].ingredientId;
            }
        }

        // Second required group mirrors the same default logic.
        let requiredId2 = parseInt(this.state.selectedRequiredProductIngredient2);
        if (!requiredId2) {
            const reqs2 = (currentProduct.product_ingredients || []).filter(pi => pi.type == 'required2' && productIngredients[pi.ingredientId] && productIngredients[pi.ingredientId].active == true);
            if (reqs2[0] && reqs2[0].ingredientId) {
                requiredId2 = reqs2[0].ingredientId;
            }
        }

        const item = {
            kcal: base.kcal, protein: base.protein, carbs: base.carbs, fat: base.fat,
            product_ingredients: currentProduct.product_ingredients || [],
            ingredients: {
                required: requiredId,
                required2: requiredId2,
                addable: this.state.selectedAddableProductIngredients || [],
                // Всяка избрана опция от група влиза в живото пресмятане (2x кюфте = 2x).
                groups: this.getGroupSelectionsWithDefaults(),
            },
            quantity: 1,
        };
        const n = Utils.calculateProductNutritionOrder(item, productIngredients, 1);
        if (!(n.kcal > 0 || n.protein > 0 || n.carbs > 0 || n.fat > 0)) {
            return null;
        }

        const t = (translations && translations.translations && translations.translations.common) || {};
        const title = t.nutrition_title || 'Хранителна информация';
        const lblKcal = t.nutrition_kcal_short || 'kcal';
        const lblProtein = t.nutrition_protein_short || 'protein';
        const lblCarbs = t.nutrition_carbs_short || 'carbs';
        const lblFat = t.nutrition_fat_short || 'fat';

        // Only the values the restaurant actually filled in - a 0 means "not entered", not "zero grams".
        const cells = [
            { key: 'kcal', value: n.kcal, text: `${Math.round(n.kcal)}`, label: lblKcal },
            { key: 'protein', value: n.protein, text: `${n.protein}g`, label: lblProtein },
            { key: 'carbs', value: n.carbs, text: `${n.carbs}g`, label: lblCarbs },
            { key: 'fat', value: n.fat, text: `${n.fat}g`, label: lblFat },
        ].filter(c => c.value > 0);

        return (
            <div className={classes.nutritionContainer} data-class="product-view-page-nutrition">
                <div className={classes.nutritionTitle}>{title}</div>
                <div className={classes.nutritionGrid} style={{ gridTemplateColumns: `repeat(${cells.length}, 1fr)` }}>
                    {cells.map(c =>
                        <div className={classes.nutritionCell} key={c.key}>
                            <span className={clsx(classes.nutritionValue, 'skiptranslate')}>{c.text}</span>
                            <span className={classes.nutritionLabel}>{c.label}</span>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { classes, settings, translations, currentProduct, currLang, selectedCat, categories_hierarchy, view_product_page_id } = this.props;
        let { id, name, product_variants, product_ingredients, product_images, description, allergens, subcategory, in_stock, label, hide_for_ordering, discount_percent, discount_money } = currentProduct;
        name = currentProduct && currentProduct.translations && currentProduct.translations[currLang] && currentProduct.translations[currLang].name ? currentProduct.translations[currLang].name : name;
        description = currentProduct && currentProduct.translations && currentProduct.translations[currLang] && currentProduct.translations[currLang].description ? currentProduct.translations[currLang].description : description;

        // time based discount
        // Проверка за времева отстъпка и презаписване на discount_percent
        if (currentProduct.time_based_discount_enabled) {
            const now = new Date();
            const currentHour = now.getHours();
            const currentDay = now.getDay(); // 0 = неделя, 1 = понеделник

            // Парсваме JSON данните за дните
            let allowedDays = [];
            try {
                allowedDays = typeof currentProduct.time_based_discount_days === 'string'
                    ? JSON.parse(currentProduct.time_based_discount_days)
                    : currentProduct.time_based_discount_days || [];
            } catch (e) {
                allowedDays = [];
            }

            // Проверка на ден и час
            const isDayValid = allowedDays.includes(currentDay);
            const startHour = currentProduct.time_based_discount_start_hour || 0;
            const endHour = currentProduct.time_based_discount_end_hour || 23;

            let isTimeValid = false;
            if (endHour < startHour) {
                isTimeValid = currentHour >= startHour || currentHour <= endHour;
            } else {
                isTimeValid = currentHour >= startHour && currentHour <= endHour;
            }

            // Ако условията са изпълнени, презаписваме discount_percent
            if (isDayValid && isTimeValid) {
                discount_percent = currentProduct.time_based_discount_percent || 0;
            }
        }
        // time based discount

        let prodImgPath = '';
        if (product_images && typeof product_images[0] !== "undefined" && typeof product_images[0].path !== "undefined" && product_images[0].path) {
            prodImgPath = Utils.getProductImagePath(product_images[0].path);
        }
        // Нарочно БЕЗ fallback към дифолтна снимка тук: ако продуктът няма снимка,
        // на view страницата не показваме нищо (грозно е и се отваря на цял екран).

        // Логото на обекта като fallback, когато продуктът няма снимка (само ако `show_logo_when_no_image_product_page` е включена).
        // Ако е качено отделно лого само за продукти без снимка (`product_no_image_logo`), то има приоритет пред логото на обекта.
        const placeLogoPath = Utils.getSettingsPath(Utils.getSettingsValue(settings, 'product_no_image_logo'))
            || Utils.getSettingsPath(Utils.getSettingsValue(settings, 'logo'))
            || Utils.getSettingsPath(Utils.getSettingsValue(settings, 'tabl_logo'));
        const viewLogoFallback = (!prodImgPath && Utils.getSetting('show_logo_when_no_image_product_page') == 1 && placeLogoPath) ? placeLogoPath : '';

        if (!product_variants) {
            product_variants = [];
        }
        if (!product_ingredients) {
            product_ingredients = [];
        }

        let currentProductCats = [];
        if (currentProduct && currentProduct.catHierarchyIds) {
            currentProductCats = currentProduct.catHierarchyIds;
        }
        let order_allowed = Utils.checkProductAllowedOrdering(currentProductCats, categories_hierarchy);

        if (Utils.getSetting('hide_add_to_cart_btn') == 1) {
            order_allowed = false;
        }

        let addableProductIngridients = [];
        let removableProductIngridients = [];
        let requiredProductIngridients = [];
        let requiredProductIngridients2 = [];
        if (product_ingredients.length > 0 && this.props.productIngredients && Object.values(this.props.productIngredients).length > 0) {
            addableProductIngridients = product_ingredients.filter(pi => pi.type == 'addable' && this.props.productIngredients[pi.ingredientId] && this.props.productIngredients[pi.ingredientId].active == true);
            removableProductIngridients = product_ingredients.filter(pi => pi.type == 'removable' && this.props.productIngredients[pi.ingredientId] && this.props.productIngredients[pi.ingredientId].active == true);
            requiredProductIngridients = product_ingredients.filter(pi => pi.type == 'required' && this.props.productIngredients[pi.ingredientId] && this.props.productIngredients[pi.ingredientId].active == true);
            requiredProductIngridients2 = product_ingredients.filter(pi => pi.type == 'required2' && this.props.productIngredients[pi.ingredientId] && this.props.productIngredients[pi.ingredientId].active == true);
        }

        var spotBrowseOnly = false;
        if (Auth.getTokenOrderType() || this.props.chosenPlaceOrderTypes.length == 1) {
            if (Auth.getTokenOrderType()) {
                var type = this.props.chosenPlaceOrderTypes.find(ot => ot.id === Auth.getTokenOrderType())

                if (type && type.type) {
                    type = type.type;
                }
                // FIXED? Potential bug - once it crashed because of .type not found
                // console.log('type', type);

                if (type == "spot_browse" || type == 'tablet_mode') {
                    spotBrowseOnly = true;
                }
            } else {
                if (this.props.chosenPlaceOrderTypes.length == 1) {
                    if (this.props.chosenPlaceOrderTypes && this.props.chosenPlaceOrderTypes[0] && this.props.chosenPlaceOrderTypes[0].type && (this.props.chosenPlaceOrderTypes[0].type == 'spot_browse' || this.props.chosenPlaceOrderTypes[0].type == 'tablet_mode')) {
                        spotBrowseOnly = true;
                    }
                }
            }
        }

        // console.log('Utils.getSettingsValue(add_to_cart_view_page_button_position) ', Utils.getSettingsValue(settings, 'add_to_cart_view_page_button_position')) )
        return (
            <Fade in={view_product_page_id != 0}>
                <div className={classes.viewProductContainer} style={{ display: (!(view_product_page_id != 0) ? 'none' : 'block') }} data-class="view-product-page" >

                    <div className={classes.productInfoContainer}
                        // Без снимка → текстът заема цялата ширина (иначе остава празна 45% колона).
                        style={{ gridTemplateColumns: (prodImgPath || viewLogoFallback) ? undefined : '1fr' }}>
                        {(prodImgPath || viewLogoFallback) ?
                            <div className={classes.productImageContainer}
                                onClick={() => prodImgPath ? this.setState({ photoOpened: true }) : void (0)}
                                style={{
                                    cursor: prodImgPath ? 'pointer' : 'default',
                                    // Wrap-ваме в кавички и escape-ваме " / \ за да не се чупи CSS url()
                                    // когато името на снимката съдържа скоби, апостроф, интервал и т.н.
                                    backgroundImage: `url("${(prodImgPath || viewLogoFallback).replace(/\\/g, '\\\\').replace(/"/g, '\\"')}")`,
                                    // Логото показваме contain (центрирано, без изрязване).
                                    backgroundSize: (viewLogoFallback && !prodImgPath) ? 'contain' : (currentProduct.isLiquid == 1 ? 'contain' : 'cover'),
                                    // Обща фонова снимка зад снимката на продукта (product_image_background) - не и зад логото при липсваща снимка.
                                    ...(prodImgPath ? Utils.getImageWithBackgroundStyle(prodImgPath.replace(/\\/g, '\\\\').replace(/"/g, '\\"'), currentProduct.isLiquid == 1 ? 'contain' : 'cover') : {}),
                                }} data-class="view-product-page-image">
                                {/* <img className={classes.productImage} src={prodImgPath} /> */}

                                {prodImgPath && this.state.photoOpened && (
                                    <Lightbox
                                        imageTitle={name}
                                        imageCaption={description && description.length > 0 ? description.toString().replace(/<[^>]*>/g, '') : ''}
                                        mainSrc={[prodImgPath]}
                                        onCloseRequest={() => this.setState({ photoOpened: false })}
                                    />
                                )}

                            </div >
                            :
                            null
                        }
                        <div className={classes.productTextContainer}>
                            <div>
                                <div className={classes.productNameContainer} data-class="product-view-page-title"
                                    dangerouslySetInnerHTML={{
                                        __html: name
                                    }}></div>

                                {description && description.length > 0 ?
                                    <React.Fragment>
                                        <br />
                                        <div className={classes.productDescriptionContainer} data-class="product-view-page-description"
                                            dangerouslySetInnerHTML={{
                                                __html: description
                                            }}></div>
                                    </React.Fragment>
                                    :
                                    null
                                }

                                <div className={classes.ProductVariantsContainer} data-class="product-view-page-variants">

                                    <Collapse in={this.state.viewPageError} timeout="auto" unmountOnExit>
                                        <p className={classes.errorContainer}>{this.state.viewPageError}</p>
                                    </Collapse>

                                    {/* Product variants */}
                                    {product_variants.length > 1 ?
                                        <React.Fragment>
                                            <p><b>{translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.choose_size ? translations.translations.pages.products.choose_size : ''}:</b></p>
                                        </React.Fragment>
                                        :
                                        null
                                    }

                                    {product_variants.map((variant, k) => {
                                        let calculatedProductPrice = Utils.calculateProductPriceListingProducts(variant.price, discount_percent, discount_money, settings);

                                        return (
                                            <ListItem button className={this.state.productActiveVariantId == variant.id ? classes.activeProductVariant : {}} key={k} onClick={() => this.setState({ productActiveVariantId: variant.id })} data-class="product-variant-button-viewpage" >
                                                <Checkbox className={classes.variantCheckbox} checked={this.state.productActiveVariantId == variant.id} data-class="variant-checkbox" />
                                                <Grid item xs={7} >
                                                    {/* {variant.size} */}
                                                    {variant.translations[this.props.currLang] && variant.translations[this.props.currLang].size || variant.size}
                                                </Grid>
                                                <Grid item xs={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                    {(discount_percent && parseFloat(discount_percent) != 0) || (discount_money && parseFloat(discount_money) != 0 & Utils.getSettingsValue(settings, 'calculate_product_discount_money_only_for_preorder_orders') != 1) ?
                                                        <React.Fragment>
                                                            <span className="strikethrough"><span className={classes.oldPrice}>{variant.price}{settings.default_currency_suffix && settings.default_currency_suffix.value ? ' ' + settings.default_currency_suffix.value : translations.translations && translations.translations.common && translations.translations.common.currency_bgn || ' лв.'}{Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ? ' / ' + Utils.showPricesInEuroCurrency(variant.price) : null}</span></span>&nbsp;

                                                            {Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ?
                                                                <br />
                                                                :
                                                                null
                                                            }

                                                        </React.Fragment>
                                                        :
                                                        null
                                                    }

                                                    {calculatedProductPrice.includes('.') ?
                                                        <React.Fragment>
                                                            {calculatedProductPrice.split('.')[0]}<span data-class="product-variant-price-dot">.</span><span data-class="product-variant-price-cents">{calculatedProductPrice.split('.')[1]}</span>
                                                        </React.Fragment>
                                                        :
                                                        calculatedProductPrice
                                                    }

                                                    {settings.default_currency_suffix && settings.default_currency_suffix.value ? ' ' + settings.default_currency_suffix.value : ' лв.'}


                                                    {Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ?
                                                        <>
                                                            /
                                                            <span className='skiptranslate'>
                                                                {calculatedProductPrice.includes('.') ?
                                                                    <React.Fragment>
                                                                        {Utils.showPricesInEuroCurrency(calculatedProductPrice).split('.')[0]}<span data-class="product-variant-price-dot">.</span><span data-class="product-variant-price-cents">{Utils.showPricesInEuroCurrency(calculatedProductPrice).split('.')[1]}</span>
                                                                    </React.Fragment>
                                                                    :
                                                                    Utils.showPricesInEuroCurrency(calculatedProductPrice)
                                                                }
                                                            </span>
                                                        </>
                                                        :
                                                        null
                                                    }
                                                </Grid>
                                            </ListItem>
                                        )
                                    })}
                                </div>

                                {/* <div className={classes.addToCartButton}>Добави в количката</div> */}

                                {Utils.getSetting('hide_add_to_cart_btn') == 1 || (Utils.getSetting('hide_add_to_cart_btn') == 2 && spotBrowseOnly == 1) ?
                                    null
                                    :
                                    <>
                                        {product_variants.length > 0 && order_allowed && (Utils.getSettingsValue(settings, 'add_to_cart_view_page_button_position') == 'top' || Utils.getSettingsValue(settings, 'add_to_cart_view_page_button_position') == 'both') ?
                                            <Button className={classes.addToCartButton} onClick={() => this.addToCartBtnClicked(this.props.view_product_page_id, this.state.productActiveVariantId)} data-class="view-page-add-to-cart">
                                                <AddShoppingCartIcon style={{ verticalAlign: 'middle' }} />&nbsp;
                                                {Auth.isTabletMode() ?
                                                    (translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.save_for_order ? translations.translations.pages.products.save_for_order : '')
                                                    :
                                                    (Utils.getSettingsValue(settings, 'add_to_cart_view_page_text') || (translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.add_to_cart ? translations.translations.pages.products.add_to_cart : ''))
                                                }
                                            </Button>
                                            :
                                            null
                                        }
                                    </>
                                }
                                {!order_allowed ? <div className={classes.productSubContainer}>{translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.order_disabled ? translations.translations.pages.products.order_disabled : ''}</div> : null}

                                <div className={classes.ProductIngridientsContainer}>

                                    {/* {requiredProductIngridients.length > 1 || addableProductIngridients.length > 0 || removableProductIngridients.length > 0 ?
                                        <>
                                            <hr data-class="separating-line-view-product-page" />
                                            <br />
                                        </>
                                        :
                                        null
                                    } */}

                                    {/* Конфигурируеми групи ("Протеин", "Гарнитура"...). Показват се
                                        НАД старите секции. Продукт без групи не рендерира нищо. */}
                                    <IngredientGroupsSelector
                                        groups={this.getProductIngredientGroups()}
                                        value={this.state.selectedIngredientGroups}
                                        onChange={selections => this.setState({ selectedIngredientGroups: selections })}
                                        productIngredients={this.props.productIngredients}
                                        settings={settings}
                                        currLang={this.props.currLang}
                                        requiredLabel={translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.required ? translations.translations.pages.products.required : 'Задължително'}
                                    />

                                    {requiredProductIngridients.length > 1 ?
                                        <React.Fragment>
                                            <p data-class="product-ingridients-container-title" className={classes.productIngredientsContainerTitle}>
                                                {Utils.getSettingsValue(settings, 'required_ingredients_title') ?
                                                    Utils.getSettingsValue(settings, 'required_ingredients_title')
                                                    :
                                                    (translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.additional_options ? translations.translations.pages.products.additional_options : '')
                                                }:
                                            </p>
                                        </React.Fragment>
                                        :
                                        null
                                    }

                                    {requiredProductIngridients.length > 1 ?

                                        <FormControl component="fieldset">
                                            <RadioGroup row className={classes.groupContainer}
                                                value={parseInt(this.state.selectedRequiredProductIngredient) > 0 ? this.state.selectedRequiredProductIngredient : (requiredProductIngridients && requiredProductIngridients[0] && requiredProductIngridients[0].ingredientId ? requiredProductIngridients[0].ingredientId : '')}
                                                onChange={(e) => this.setState({ selectedRequiredProductIngredient: parseInt(e.target.value) })} >
                                                {requiredProductIngridients.map((ingridient, k) => {
                                                    let produtIngridientName = this.props.productIngredients && this.props.productIngredients[ingridient.ingredientId] && this.props.productIngredients[ingridient.ingredientId].name ? this.props.productIngredients[ingridient.ingredientId].name : '';

                                                    if (this.props.productIngredients && this.props.productIngredients[ingridient.ingredientId] && this.props.productIngredients[ingridient.ingredientId].price && this.props.productIngredients[ingridient.ingredientId].price != 0) {
                                                        produtIngridientName += ' ( + ' + this.props.productIngredients[ingridient.ingredientId].price + ' ' + (settings.default_currency_suffix && settings.default_currency_suffix.value ? ' ' + settings.default_currency_suffix.value : ' лв.') +
                                                            (Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ? ' / ' + (Utils.showPricesInEuroCurrency(this.props.productIngredients[ingridient.ingredientId].price)) : '')
                                                            + ')';


                                                    }
                                                    return (
                                                        <FormControlLabel
                                                            value={ingridient.ingredientId}
                                                            control={
                                                                <Radio
                                                                    className={classes.requiredIngredientsRadio}
                                                                    data-class="required-each-ingredient"
                                                                />
                                                            }
                                                            label={produtIngridientName}
                                                            data-class="required-ingredients-container"
                                                        />
                                                    )
                                                })}
                                            </RadioGroup>
                                        </FormControl>
                                        :
                                        null
                                    }

                                    {/* Second required group (e.g. choose one salad). Independent single-choice radio group. */}
                                    {requiredProductIngridients2.length > 1 ?
                                        <React.Fragment>
                                            <p data-class="product-ingridients-container-title-2" className={classes.productIngredientsContainerTitle}>
                                                {Utils.getSettingsValue(settings, 'required_ingredients_title_2') ?
                                                    Utils.getSettingsValue(settings, 'required_ingredients_title_2')
                                                    :
                                                    (translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.additional_options ? translations.translations.pages.products.additional_options : '')
                                                }:
                                            </p>
                                        </React.Fragment>
                                        :
                                        null
                                    }

                                    {requiredProductIngridients2.length > 1 ?

                                        <FormControl component="fieldset">
                                            <RadioGroup row className={classes.groupContainer}
                                                value={parseInt(this.state.selectedRequiredProductIngredient2) > 0 ? this.state.selectedRequiredProductIngredient2 : (requiredProductIngridients2 && requiredProductIngridients2[0] && requiredProductIngridients2[0].ingredientId ? requiredProductIngridients2[0].ingredientId : '')}
                                                onChange={(e) => this.setState({ selectedRequiredProductIngredient2: parseInt(e.target.value) })} >
                                                {requiredProductIngridients2.map((ingridient, k) => {
                                                    let produtIngridientName = this.props.productIngredients && this.props.productIngredients[ingridient.ingredientId] && this.props.productIngredients[ingridient.ingredientId].name ? this.props.productIngredients[ingridient.ingredientId].name : '';

                                                    if (this.props.productIngredients && this.props.productIngredients[ingridient.ingredientId] && this.props.productIngredients[ingridient.ingredientId].price && this.props.productIngredients[ingridient.ingredientId].price != 0) {
                                                        produtIngridientName += ' ( + ' + this.props.productIngredients[ingridient.ingredientId].price + ' ' + (settings.default_currency_suffix && settings.default_currency_suffix.value ? ' ' + settings.default_currency_suffix.value : ' лв.') +
                                                            (Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ? ' / ' + (Utils.showPricesInEuroCurrency(this.props.productIngredients[ingridient.ingredientId].price)) : '')
                                                            + ')';


                                                    }
                                                    return (
                                                        <FormControlLabel
                                                            value={ingridient.ingredientId}
                                                            control={
                                                                <Radio
                                                                    className={classes.requiredIngredientsRadio}
                                                                    data-class="required-each-ingredient-2"
                                                                />
                                                            }
                                                            label={produtIngridientName}
                                                            data-class="required-ingredients-container-2"
                                                        />
                                                    )
                                                })}
                                            </RadioGroup>
                                        </FormControl>
                                        :
                                        null
                                    }

                                    {addableProductIngridients.length > 0 ?
                                        <React.Fragment>
                                            <p data-class="product-ingridients-container-title" className={classes.productIngredientsContainerTitle}>
                                                {Utils.getSettingsValue(settings, 'addable_ingredients_title') ?
                                                    Utils.getSettingsValue(settings, 'addable_ingredients_title')
                                                    :
                                                    (translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.addable_options ? translations.translations.pages.products.addable_options : '')
                                                }:
                                            </p>
                                        </React.Fragment>
                                        :
                                        null
                                    }

                                    {addableProductIngridients.length > 0 ?
                                        <FormControl component="fieldset" >
                                            <FormGroup row className={classes.groupContainer}>
                                                {addableProductIngridients.sort(this.ingredientsSortFunc).map((ingridient, k) =>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox className={classes.addableIngredientsCheckbox}
                                                                checked={this.checkedIngredient(ingridient.type, ingridient.ingredientId)}
                                                                onChange={(e) => this.handleIngridientChangeObject(e, ingridient)}
                                                                data-class="addable-each-ingredient"
                                                            />
                                                        }
                                                        label={this.props.productIngredients && this.props.productIngredients[ingridient.ingredientId] && this.props.productIngredients[ingridient.ingredientId].name ? (this.props.productIngredients[ingridient.ingredientId].name + ' ( + ' + this.props.productIngredients[ingridient.ingredientId].price + ' ' + (settings.default_currency_suffix && settings.default_currency_suffix.value ? ' ' + settings.default_currency_suffix.value : ' лв.') +
                                                            (Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ? ' / ' + (Utils.showPricesInEuroCurrency(this.props.productIngredients[ingridient.ingredientId].price)) : '')
                                                            + ')') : ''}
                                                        data-class="addable-ingredients-container"
                                                    />
                                                )}
                                            </FormGroup>
                                        </FormControl>
                                        :
                                        null
                                    }


                                    {removableProductIngridients.length > 0 ?
                                        <React.Fragment>
                                            <p data-class="product-ingridients-container-title" className={classes.productIngredientsContainerTitle}>

                                                {Utils.getSettingsValue(settings, 'removeable_ingredients_title') ?
                                                    Utils.getSettingsValue(settings, 'removeable_ingredients_title')
                                                    :
                                                    (translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.removable_options ? translations.translations.pages.products.removable_options : '')
                                                }:
                                            </p>
                                        </React.Fragment>
                                        :
                                        null
                                    }

                                    {removableProductIngridients.length > 0 ?
                                        <FormControl component="fieldset" >
                                            <FormGroup row className={classes.groupContainer}>
                                                {removableProductIngridients.sort(this.ingredientsSortFunc).map((ingridient, k) =>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox className={classes.removableIngredientsCheckbox}
                                                                // checked={this.checkedIngredient(ingridient.type, ingridient.ingredientId)}
                                                                onChange={(e) => this.handleIngridientChangeObject(e, ingridient)}
                                                                data-class="removable-each-ingredient"
                                                            />
                                                        }
                                                        label={this.props.productIngredients && this.props.productIngredients[ingridient.ingredientId] && this.props.productIngredients[ingridient.ingredientId].name ? this.props.productIngredients[ingridient.ingredientId].name : ''}
                                                        data-class="removable-ingredients-container"
                                                    />
                                                )}
                                            </FormGroup>
                                        </FormControl>
                                        :
                                        null
                                    }


                                </div>

                                {this.renderProductNutrition()}

                                {product_variants.length > 0 && order_allowed ?
                                    <TextField
                                        className={classes.commentTextField}
                                        onChange={e => this.setState({ productComment: e.target.value })}
                                        label={currentProduct && currentProduct.comment_placeholder ? currentProduct.comment_placeholder : translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.comment ? translations.translations.pages.products.comment : ''}
                                        value={this.state.productComment}
                                        multiline
                                        rows="2"
                                        variant="outlined"
                                        data-class="product-view-page-comments-container"
                                    />
                                    :
                                    null
                                }

                                {Utils.getSetting('hide_add_to_cart_btn') == 1 || (Utils.getSetting('hide_add_to_cart_btn') == 2 && spotBrowseOnly == 1) ?
                                    null
                                    :
                                    <>
                                        {product_variants.length > 0 && order_allowed && (Utils.getSettingsValue(settings, 'add_to_cart_view_page_button_position') == 'bottom' || Utils.getSettingsValue(settings, 'add_to_cart_view_page_button_position') == 'both') ?
                                            <Button className={classes.addToCartButton} onClick={() => this.addToCartBtnClicked(this.props.view_product_page_id, this.state.productActiveVariantId)} data-class="view-page-add-to-cart">
                                                <AddShoppingCartIcon style={{ verticalAlign: 'middle' }} />&nbsp;{Utils.getSettingsValue(settings, 'add_to_cart_view_page_text') || (translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.add_to_cart ? translations.translations.pages.products.add_to_cart : '')}
                                            </Button>
                                            :
                                            null
                                        }
                                    </>
                                }

                                <Button className={classes.backButton} onClick={this.goBackFromProduct} data-class="view-page-back">
                                    <ArrowBackIcon style={{ verticalAlign: 'middle' }} />&nbsp;{translations && translations.translations && translations.translations.common && translations.translations.common.action && translations.translations.common.action.back ? translations.translations.common.action.back : 'Назад'}
                                </Button>

                                {allergens && Object.values(allergens).length > 0 ?
                                    <div className={classes.allergensContainer} data-class="product-view-page-allergens">
                                        <br />
                                        <b>{translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.alergens ? translations.translations.pages.products.alergens : ''}:</b>
                                        <br />
                                        {Object.values(allergens).map(al => (
                                            <ListItemText primary={(al.translations && al.translations[currLang] && al.translations[currLang].name) || al.name} />
                                        ))}
                                    </div>
                                    :
                                    null
                                }

                                {currentProduct && currentProduct.minimum_durability ?
                                    <div data-class="product-view-page-durability" style={{ fontWeight: 'bold', fontSize: 15, marginTop: 8 }}>
                                        {Utils.translate((translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.minimum_durability) || 'Срок на минимална трайност: до {value} часа след приготвяне', { value: currentProduct.minimum_durability })}
                                    </div>
                                    :
                                    null
                                }

                            </div>
                        </div >


                        {/* <MetaAndOg subcategory={subcategoryName} image={Utils.getSubcategoryImagePath(subcategoryIcon)} />

                        {this.designVariantButtons()}

                        <Grid
                            className={classes.productsContainer}
                            container
                            direction="row"
                            //   justify="space-between"
                            //   justify="center"
                            // alignItems="center"
                            spacing={3}
                        >

                            {subcategory && subcategory.products ?
                                (Object.values(subcategory.products).map((product, k) => (
                                    <ProductListItem
                                        key={k}
                                        k={k}
                                        product={product}
                                        settings={settings}
                                        addProdToCart={this.addProdToCart}
                                        addToCartBtnClicked={this.addToCartBtnClicked}
                                        translations={translations}
                                        currLang={this.props.currLang}
                                    />
                                )))
                                :
                                ''
                            }

                        </Grid>

                        <ProductVariantsModal
                            open={this.state.variantModalOpen}
                            variantModalWithComment={this.state.variantModalWithComment}
                            product={this.state.selectedProduct}
                            addProdToCart={this.addProdToCart}
                            order_comment={this.props.products.order_comment}
                            setOrderComment={this.props.setOrderComment}
                            closeProductVariantModalHandler={() => this.setState({ variantModalOpen: !this.state.variantModalOpen })}
                            settings={settings}
                            translations={translations}
                            currLang={this.props.currLang}
                        /> */}

                    </div>

                    <div className={classes.similarProductsContainer} data-class="similar-products-view-page">{translations && translations.translations && translations.translations.pages && translations.translations.pages.products && translations.translations.pages.products.related_products ? translations.translations.pages.products.related_products : ''}</div>

                    <Grid
                        className={classes.productsContainer}
                        container
                        direction="row"
                        //   justify="space-between"
                        //   justify="center"
                        // alignItems="center"
                        spacing={3}
                    >

                        {view_product_page_id != 0 ?
                            ((this.props.similarProducts).filter(p => p && p.id).map((product, k) => (
                                <ProductListItem
                                    preventGrow={true}
                                    key={product.id}
                                    k={k}
                                    scrollToTopAfterClick={true}
                                    product={product}
                                    settings={settings}
                                    // addProdToCart={() => void (0)}
                                    // addToCartBtnClicked={() => void (0)}
                                    addProdToCart={this.addProdToCart}
                                    addToCartBtnClicked={(a, b) => this.addToCartBtnClicked(a, b, false)}
                                    translations={translations}
                                    currLang={this.props.currLang}
                                    // setCommentModalProps={(commentModalTitle, commentVariantId) => { this.setState({ openCommentModal: true, commentModalTitle: commentModalTitle, commentVariantId: commentVariantId }) }}
                                    setCommentModalProps={(commentModalTitle, commentVariantId) => { this.props.setCommentModalData(true, commentModalTitle, commentVariantId) }}
                                    viewProductPage={true}
                                />
                            )))
                            :
                            ''
                        }

                    </Grid>


                    {Utils.getSettingsValue(settings, 'show_footer') != '' ?
                        <ProductsFooterContainer settings={settings} translations={translations} />
                        :
                        null
                    }

                </div>

            </Fade >
        );
    }

}

// Caches the chosen "related products" suggestion IDs per current-product id, keeping the
// order stable across unrelated re-renders (e.g. cart updates) so the list does not keep
// reshuffling under the user.
const similarProductsIdCache = {};

const mapStateToProps = (state, ownProps) => {
    // ownProps.match.params

    const prodSlug = ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.prodSlug ? ownProps.match.params.prodSlug : '';
    let viewProductPageId = state.products.view_product_page_id || 0;
    //const currentProduct = state.products.view_product_page_id && state.products && state.products.all_products && state.products.all_products[viewProductPageId] ? state.products.all_products[viewProductPageId] : []
    let currentProduct = state.products && state.products.all_products && Object.values(state.products.all_products).find(p => p.slug == prodSlug);
    if (!currentProduct) {
        currentProduct = {};
    }
    let similarProducts = [];

    var catsHierarchy = state.categories.categories_hierarchy || [];
    let catSlug = ownProps.match.params.catSlug !== "null" ? ownProps.match.params.catSlug : "";
    let selectedCat = catsHierarchy && Object.values(catsHierarchy).filter(c => c.slug === catSlug)[0] ? Object.values(catsHierarchy).filter(c => c.slug === catSlug)[0] : null;

    const shuffleArr = (arr) => {
        const a = arr.slice();
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    };

    if (state.products.view_product_page_id && currentProduct && currentProduct.id) {
        const allProductsArr = Object.values(state.products.all_products || {});

        // The chosen suggestion IDs are cached per product so the order stays stable across
        // unrelated state changes (cart updates, periodic refreshes, etc.) — without the cache
        // mapStateToProps re-runs the random shuffle on every render and the list keeps reshuffling.
        let cachedIds = similarProductsIdCache[currentProduct.id];
        if (!cachedIds) {
            let chosen = [];

            // 1. Админски избрани свързани продукти (от EditProductPage -> RelatedProductsTab)
            if (currentProduct.related_products && currentProduct.related_products.length > 0) {
                chosen = currentProduct.related_products
                    .map(rid => allProductsArr.find(p => p.id == rid))
                    .filter(p => p && p.id != currentProduct.id);
            }

            // 2. Иначе - случайни от същата категория
            if (chosen.length == 0) {
                const currentProductCatIds = currentProduct.catHierarchyIds || [];
                const sameCategoryProducts = allProductsArr.filter(p =>
                    p.id != currentProduct.id
                    && p.catHierarchyIds
                    && p.catHierarchyIds.some(cid => currentProductCatIds.includes(cid))
                );
                chosen = shuffleArr(sameCategoryProducts).slice(0, 4);
            }

            // 3. Fallback - случайни от всички продукти
            if (chosen.length == 0) {
                const others = allProductsArr.filter(p => p.id != currentProduct.id);
                chosen = shuffleArr(others).slice(0, 4);
            }

            cachedIds = chosen.map(p => p.id);
            // Only memoize once we actually have results — empty list usually means all_products
            // is still loading; we want to retry on the next render.
            if (cachedIds.length > 0) {
                similarProductsIdCache[currentProduct.id] = cachedIds;
            }
        }

        similarProducts = cachedIds
            .map(id => allProductsArr.find(p => p.id == id))
            .filter(Boolean);
    }
    // console.log('state', state)
    // console.log('similarProducts', similarProducts)

    let chosenPlaceOrderTypes = [];
    let chosenPlaceId = state.places.chosen_place;
    let chosenPlace = state.places.places.filter(p => p.id == chosenPlaceId);
    if (chosenPlace.length == 0) {
        chosenPlace = null;
    } else {
        chosenPlace = chosenPlace[0];
        chosenPlaceOrderTypes = chosenPlace.ordertypes;
    }

    return {
        categories_hierarchy: state.categories.categories_hierarchy || {},
        currentProdSlug: prodSlug,
        subcategory: state.products.subcat_products || null,
        selectedCat: selectedCat || null,
        isLoading: state.products.isLoading || false,
        products: state.products || [],
        categoriesLoaded: state.categories.categories_loaded || 0,
        settings: state.settings.settings || [],
        translations: state.lang,
        currLang: state.lang.currLang,
        view_product_page_id: viewProductPageId,
        currentProduct: currentProduct,
        similarProducts: similarProducts,
        productIngredients: state.products.productIngredients || [],
        ingredientGroups: state.products.ingredientGroups || {},
        chosenPlaceOrderTypes: chosenPlaceOrderTypes,

    };
};

export default withStyles(styles)(connect(mapStateToProps, { getProductsBySubcat, showHeaderCategory, addProductTooltip, addToCart, changeSelectedCartTab, setOrderComment, setMainBackground, removeProductPageId, setProductPageId, setCommentModalData, getProductIngredients, setScrollData, setAlertMessage })(ViewProductPage));